import { createContext } from 'react'

import { TopbarContextType } from './types'

export const TopbarContext = createContext<TopbarContextType>({})
